import { render } from "./RentalView.vue?vue&type=template&id=bec4fec6"
import script from "./RentalView.vue?vue&type=script&lang=js"
export * from "./RentalView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__